export const MODEL_DELETE = "modele/DELETE";
export const MODEL_SET_LIST_LOADING = "modele/SET_LIST_LOADING";
function action(type, payload = {}) {
  return { type, ...payload };
}

export const modelDelete = id => action(MODEL_DELETE, { id });
export const modelSetListLoading = loading => action(MODEL_SET_LIST_LOADING, { loading });



// WEBPACK FOOTER //
// src/redux/actions/modelActions.js